import React from 'react';
import { PEDashboardTab, PEMetricFilter, PE_METRIC_LABELS } from '@/types/pe.types';

const TABS: { key: PEDashboardTab; label: string }[] = [
  { key: PEDashboardTab.PE_TOTALS, label: 'PE Totals' },
  { key: PEDashboardTab.HDPE, label: 'HDPE' },
  { key: PEDashboardTab.LDPE, label: 'LDPE' },
  { key: PEDashboardTab.LLDPE, label: 'LLDPE' },
  { key: PEDashboardTab.FEEDSTOCKS, label: 'Feedstocks' },
  { key: PEDashboardTab.USITC, label: 'USITC' },
  { key: PEDashboardTab.MARKETS, label: 'Markets' },
  { key: PEDashboardTab.RATES, label: 'Rates' },
  { key: PEDashboardTab.FAIR_PRICE, label: 'Fair Price' },
];

const INVENTORY_TABS = new Set([
  PEDashboardTab.PE_TOTALS,
  PEDashboardTab.HDPE,
  PEDashboardTab.LDPE,
  PEDashboardTab.LLDPE,
]);

interface PENavTabsProps {
  activeTab: PEDashboardTab;
  onTabChange: (tab: PEDashboardTab) => void;
  activeMetric: PEMetricFilter;
  onMetricChange: (metric: PEMetricFilter) => void;
}

const PENavTabs: React.FC<PENavTabsProps> = ({
  activeTab,
  onTabChange,
  activeMetric,
  onMetricChange,
}) => {
  const showMetricFilters = INVENTORY_TABS.has(activeTab);

  return (
    <div className="bg-rs-off-black border-b border-rs-jet-light">
      {/* Main tab row */}
      <div className="flex flex-wrap gap-1 px-4 pt-3 pb-2">
        {TABS.map(({ key, label }) => (
          <button
            key={key}
            onClick={() => onTabChange(key)}
            className={`px-4 py-1.5 rounded-full text-sm font-medium transition-colors ${
              activeTab === key
                ? 'bg-rs-green text-black'
                : 'bg-rs-jet text-rs-off-white/70 hover:bg-rs-jet-light hover:text-rs-off-white'
            }`}
          >
            {label}
          </button>
        ))}
      </div>

      {/* Metric filter row — shown only for inventory tabs */}
      {showMetricFilters && (
        <div className="flex flex-wrap gap-1 px-4 pb-3">
          {(Object.values(PEMetricFilter) as PEMetricFilter[]).map((metric) => (
            <button
              key={metric}
              onClick={() => onMetricChange(metric)}
              className={`px-3 py-1 rounded text-xs font-medium transition-colors ${
                activeMetric === metric
                  ? 'bg-rs-green text-black'
                  : 'bg-rs-jet text-rs-off-white/50 hover:bg-rs-jet-light'
              }`}
            >
              {PE_METRIC_LABELS[metric]}
            </button>
          ))}
        </div>
      )}
    </div>
  );
};

export default PENavTabs;
